<app-document-status-badge [documentStatus]="dataItem?.status"></app-document-status-badge>